import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-376b3724"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "assist-page"
};
const _hoisted_2 = {
  class: "light-animation"
};
const _hoisted_3 = {
  class: "page-content"
};
const _hoisted_4 = {
  class: "invite-header"
};
const _hoisted_5 = {
  key: 0,
  class: "inviter-row"
};
const _hoisted_6 = {
  class: "avatar-wrap"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "assist-badge"
}, "求助力", -1));
const _hoisted_8 = {
  class: "inviter-info"
};
const _hoisted_9 = {
  class: "nickname"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "invite-desc"
}, "邀请你一起参与抽奖", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "quote-icon",
  src: "https://p6.moimg.net/wxapp/prize_top_title_left.png",
  alt: ""
}, null, -1));
const _hoisted_12 = {
  class: "invite-title"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 一起");
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "拼手气赢奖", -1));
const _hoisted_16 = {
  class: "invite-subtitle"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "header-gift",
  src: "https://p6.moimg.net/wxapp/prize_detail_gift_green.png",
  alt: "礼物"
}, null, -1));
const _hoisted_18 = {
  key: 0,
  class: "prize-card"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "activity-chip"
}, "🎟️", -1));
const _hoisted_20 = {
  class: "activity-title"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "view-link"
}, [/*#__PURE__*/_createTextVNode(" 查看活动 "), /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/wxapp/prize_detail_arrow_gray.png",
  alt: ""
})], -1));
const _hoisted_22 = {
  key: 0,
  class: "single-prize"
};
const _hoisted_23 = {
  class: "single-figure"
};
const _hoisted_24 = {
  class: "single-content"
};
const _hoisted_25 = {
  class: "single-name"
};
const _hoisted_26 = {
  class: "prize-tags"
};
const _hoisted_27 = {
  key: 1,
  class: "prize-grid"
};
const _hoisted_28 = {
  class: "prize-name"
};
const _hoisted_29 = {
  class: "prize-count"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/wxapp/prize_detail_arrow_gray.png",
  alt: ""
}, null, -1));
const _hoisted_31 = {
  key: 1,
  class: "project-section"
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "project-label"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "label-dot"
}), /*#__PURE__*/_createTextVNode(" 本次抽奖来自以下项目 ")], -1));
const _hoisted_33 = {
  class: "project-card"
};
const _hoisted_34 = {
  class: "project-content"
};
const _hoisted_35 = {
  class: "project-info"
};
const _hoisted_36 = {
  class: "project-heading"
};
const _hoisted_37 = {
  key: 0,
  class: "project-type"
};
const _hoisted_38 = {
  class: "project-title"
};
const _hoisted_39 = {
  key: 0,
  class: "project-stats"
};
const _hoisted_40 = {
  key: 0
};
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/mdwxapp/project_list_money_icon.png",
  alt: ""
}, null, -1));
const _hoisted_42 = {
  key: 1
};
const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/mdwxapp/project_list_support_icon.png",
  alt: ""
}, null, -1));
const _hoisted_44 = /*#__PURE__*/_createTextVNode("人支持 ");
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" 查看项目 ");
const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/wxapp/prize_detail_arrow_gray.png",
  alt: ""
}, null, -1));
const _hoisted_47 = [_hoisted_45, _hoisted_46];
const _hoisted_48 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-spacer"
}, null, -1));
const _hoisted_49 = {
  class: "action-bar"
};
const _hoisted_50 = {
  class: "button-tip"
};
import { computed, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import env from 'md-base-tools/env';
import { assistUserActivity, getAssistDetail } from '@/api';
import MDRouter, { urlFormatToJump } from '../../service/router';
import { mdToast } from '../../utils/tools';
import { goToLogin } from '@/utils/user';
import domain from '@/service/domain';
import CompLottieAnimation from '@@/lottieAnimation.vue';
import ShareBox from '@@/common/ShareBox.vue';
export default {
  setup(__props) {
    const route = useRoute();
    const store = useStore();
    const userId = computed(() => store.state.user.userId);
    const activityId = ref('');
    const shareUserId = ref('');
    const activityTitle = ref('');
    const assistJumpUrl = ref('');
    const activityJumpUrl = ref('');
    const shareImage = ref('');
    const userInfo = ref({
      user_id: '',
      icon: '',
      nickname: ''
    });
    const prizeList = ref([]);
    const itemInfo = ref({
      item_id: '',
      item_type: '',
      item_type_name: '',
      jump_url: '',
      title: '',
      user_id: '',
      logo: '',
      backer_money: '',
      backer_count: ''
    });
    const isSelf = computed(() => {
      return Boolean(userInfo.value.user_id && userId.value && userInfo.value.user_id == userId.value);
    });
    const showUserName = computed(() => userInfo.value.nickname || '--');
    const actionBtnName = computed(() => isSelf.value ? '去邀请好友' : '为TA助力');
    const displayedPrizeList = computed(() => prizeList.value.slice(0, 3));
    const shareUrl = computed(() => {
      return `${domain.wap}/prize/assist?activity_id=${activityId.value}&share_user_id=${userId.value}`;
    });
    const shareInfo = computed(() => ({
      active_title: '',
      img: shareImage.value,
      msg_des: '好友邀你参与抽奖活动，快来参与吧！',
      qq_des: '',
      qq_share_url: shareUrl.value,
      qq_title: '好友邀你参与抽奖活动，快来参与吧！',
      qr_img: shareImage.value,
      qzone_share_url: shareUrl.value,
      share_url: shareUrl.value,
      sharelink_url: shareUrl.value,
      small_code: '',
      weibo_des: `好友邀你参与抽奖活动，快来参与吧！${shareUrl.value}（分享自@摩点）`,
      weibo_share_url: shareUrl.value,
      weibo_title: '',
      weixin_share_url: shareUrl.value,
      wxTimeline_share_url: shareUrl.value,
      wx_des: '',
      wx_title: '好友邀你参与抽奖活动，快来参与吧！'
    }));
    onMounted(() => {
      document.title = '邀请好友助力';
      getUrlParams();
      getAssistDetailData();
    });
    const getUrlParams = () => {
      activityId.value = route.query.activity_id || '';
      shareUserId.value = route.query.share_user_id || '';
    };
    const getPrizeCount = prize => prize.num || 1;
    const hasValue = value => value !== undefined && value !== null && value !== '';
    const getPrizeTypeName = prize => {
      if (prize.relation_type === 2) return '购买权';
      if (prize.relation_type === 1) return '赠品';
      return '奖品';
    };
    const triggerChangeShareStatus = () => {
      store.commit('currentShareUpdate', {
        obj: 'share_info',
        value: shareInfo.value
      });
      store.commit('changeShareStatus', {
        obj: 'showShare'
      });
    };
    const getAssistDetailData = async () => {
      if (!activityId.value || !shareUserId.value) {
        mdToast('参数错误');
        return;
      }
      const response = await getAssistDetail({
        activity_id: activityId.value,
        share_user_id: shareUserId.value
      });
      if (response && response.status === 0) {
        const data = response.data || {};
        userInfo.value = data.user_info || userInfo.value;
        prizeList.value = data.prize_list || [];
        itemInfo.value = data.item_info || itemInfo.value;
        assistJumpUrl.value = data.jump_url || '';
        activityJumpUrl.value = data.activity_info && data.activity_info.jump_url || '';
        activityTitle.value = data.activity_title || data.title || data.activity_info && data.activity_info.title || activityTitle.value;
        shareImage.value = prizeList.value.length ? prizeList.value[0].img : '';
      } else {
        mdToast(response && response.message || '请求失败');
      }
    };
    const handleViewActivity = () => {
      if (activityJumpUrl.value) {
        urlFormatToJump(activityJumpUrl.value);
      }
    };
    const handleViewProject = () => {
      if (itemInfo.value.item_id) {
        MDRouter.goProInfo(itemInfo.value.item_id);
      }
    };
    const handleAssist = async () => {
      if (!activityId.value || !shareUserId.value) {
        mdToast('参数错误');
        return;
      }
      if (!userId.value) {
        goToLogin();
        return;
      }
      if (isSelf.value) {
        if (env.isModianIos() || env.isModianAndroid()) {
          // eslint-disable-next-line no-undef
          graft.app({
            functionName: 'openShareTool',
            functionParams: JSON.parse(JSON.stringify(shareInfo.value))
          });
        } else {
          triggerChangeShareStatus();
        }
        return;
      }
      const response = await assistUserActivity({
        activity_id: activityId.value,
        share_user_id: shareUserId.value
      });
      if (response && response.status === 0) {
        mdToast('助力成功');
        if (assistJumpUrl.value) {
          urlFormatToJump(assistJumpUrl.value);
        }
      } else {
        mdToast(response && response.message || '助力失败');
      }
    };
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(CompLottieAnimation, {
        jsonUrl: "https://p6.moimg.net/wxapp/prize_assit_light.json"
      })]), _createElementVNode("main", _hoisted_3, [_createElementVNode("section", _hoisted_4, [!_unref(isSelf) ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_van_image, {
        src: userInfo.value.icon,
        fit: "cover",
        class: "avatar"
      }, null, 8, ["src"]), _hoisted_7]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(_unref(showUserName)), 1), _hoisted_10])])) : _createCommentVNode("", true), _hoisted_11, _createElementVNode("h1", _hoisted_12, [_createTextVNode(_toDisplayString(_unref(isSelf) ? '邀请好友助力' : '帮TA助力一把'), 1), _hoisted_13, _hoisted_14, _hoisted_15]), _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(isSelf) ? '每位好友助力，都会为你增加 1 个抽奖码' : '助力成功后，你也能参与本次抽奖'), 1), _hoisted_17]), prizeList.value.length ? (_openBlock(), _createElementBlock("section", _hoisted_18, [_createElementVNode("div", {
        class: "activity-row",
        onClick: handleViewActivity
      }, [_hoisted_19, _createElementVNode("span", _hoisted_20, _toDisplayString(activityTitle.value), 1), _hoisted_21]), prizeList.value.length === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createVNode(_component_van_image, {
        src: _ctx.$imgUrlFilter(prizeList.value[0].img, 196, 196),
        fit: "cover",
        class: "prize-image"
      }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, _toDisplayString(prizeList.value[0].prize_name), 1), _createElementVNode("div", _hoisted_26, [_createElementVNode("span", null, _toDisplayString(getPrizeCount(prizeList.value[0])) + "个", 1), _createElementVNode("span", null, _toDisplayString(getPrizeTypeName(prizeList.value[0])), 1)])])])) : (_openBlock(), _createElementBlock("div", _hoisted_27, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayedPrizeList), (prize, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: prize.prize_id || index,
          class: "prize-cell"
        }, [_createVNode(_component_van_image, {
          src: _ctx.$imgUrlFilter(prize.img, 196, 196),
          fit: "cover",
          class: "prize-image"
        }, null, 8, ["src"]), _createElementVNode("div", _hoisted_28, _toDisplayString(prize.prize_name), 1), _createElementVNode("div", _hoisted_29, _toDisplayString(getPrizeCount(prize)) + "个", 1)]);
      }), 128))])), prizeList.value.length > 3 ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: "card-footer all-prizes",
        onClick: handleViewActivity
      }, [_createTextVNode(" 查看全部 " + _toDisplayString(prizeList.value.length) + " 款奖品 ", 1), _hoisted_30])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), itemInfo.value.title ? (_openBlock(), _createElementBlock("section", _hoisted_31, [_hoisted_32, _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [itemInfo.value.logo ? (_openBlock(), _createBlock(_component_van_image, {
        key: 0,
        src: _ctx.$imgUrlFilter(itemInfo.value.logo, 168, 168),
        fit: "cover",
        class: "project-logo"
      }, null, 8, ["src"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [itemInfo.value.item_type_name ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(itemInfo.value.item_type_name), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_38, _toDisplayString(itemInfo.value.title), 1)]), hasValue(itemInfo.value.backer_money) || hasValue(itemInfo.value.backer_count) ? (_openBlock(), _createElementBlock("div", _hoisted_39, [hasValue(itemInfo.value.backer_money) ? (_openBlock(), _createElementBlock("span", _hoisted_40, [_hoisted_41, _createElementVNode("b", null, _toDisplayString(itemInfo.value.backer_money), 1)])) : _createCommentVNode("", true), hasValue(itemInfo.value.backer_count) ? (_openBlock(), _createElementBlock("span", _hoisted_42, [_hoisted_43, _createElementVNode("b", null, _toDisplayString(itemInfo.value.backer_count), 1), _hoisted_44])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])]), _createElementVNode("div", {
        class: "card-footer project-footer",
        onClick: handleViewProject
      }, _hoisted_47)])])) : _createCommentVNode("", true), _hoisted_48, _createElementVNode("div", _hoisted_49, [_createElementVNode("button", {
        class: "assist-button",
        onClick: handleAssist
      }, _toDisplayString(_unref(actionBtnName)), 1), _createElementVNode("div", _hoisted_50, _toDisplayString(_unref(isSelf) ? '分享给好友，助力越多中奖概率越大' : '助力后可查看完整活动与项目详情'), 1)])])]), _createVNode(ShareBox)], 64);
    };
  }
};